<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
              <work-shift>
              </work-shift> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import workShift from './todo-work-shifts'
    export default {
        components: {
            workShift
        }
    }
    </script>
    <style lang="scss">
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-work-shifts.vue